import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yii_captcha = _resolveComponent("yii-captcha")!
  const _component_yandex_captcha = _resolveComponent("yandex-captcha")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.showCaptcha('yii'))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (this.showCaptcha('yii'))
            ? (_openBlock(), _createBlock(_component_yii_captcha, {
                key: $data.captchaId,
                "model-value": $props.modelValue,
                "captcha-url": $props.configuration.captcha.config['url'],
                error: $props.error,
                onEnter: $props.onNext,
                onUpdate: $options.onUpdate
              }, null, 8 /* PROPS */, ["model-value", "captcha-url", "error", "onEnter", "onUpdate"]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (this.showCaptcha('yandex'))
      ? (_openBlock(), _createBlock(_component_yandex_captcha, {
          ref: "yandex",
          key: $data.captchaId,
          config: $props.configuration.captcha.config,
          "model-value": $props.modelValue,
          onUpdate: $options.onUpdate
        }, null, 8 /* PROPS */, ["config", "model-value", "onUpdate"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}